(() => {
 const root = document.querySelector('[data-personal-page], [data-personal-report]');
 if (!root) return;
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const captions = { love:'Connection, with room to be yourself.', career:'A direction that belongs to you.', decision:'Room for both sides of a choice.', 'self-discovery':'A closer look at your inner world.', timing:'Every beginning has its own pace.' };
 const scenes = [...root.querySelectorAll('[data-pr-scene]')];
 const renderers = new Map();
 let paused = false;
 const refreshMotion = () => scenes.forEach(scene => {
  const renderer = renderers.get(scene);
  const moving = Boolean(renderer?.loaded && renderer.animated && !paused && !reduced.matches && !document.hidden && scene.dataset.visible === 'true');
  scene.dataset.moving = String(moving);
  if (moving) renderer.start(); else renderer?.stop();
  scene.dataset.canvasReady = String(Boolean(renderer?.loaded && renderer.animated && !reduced.matches));
  const button = scene.querySelector('[data-pr-motion]');
  button.hidden = reduced.matches || !renderer?.loaded || !renderer.animated;
  button.textContent = paused ? 'Resume motion' : 'Pause motion';
  button.setAttribute('aria-pressed', String(paused));
 });
 const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => { entry.target.dataset.visible = String(entry.isIntersecting); });
  refreshMotion();
 }, {threshold:0.15});
 scenes.forEach(scene => {
  observer.observe(scene);
  scene.querySelector('[data-pr-motion]').addEventListener('click', () => { paused = !paused; refreshMotion(); });
  const fail = () => { renderers.get(scene)?.stop(); renderers.delete(scene); scene.dataset.canvasReady = 'false'; refreshMotion(); };
  if (window.PersonalEngravingMotion) {
   try {
    const renderer = new window.PersonalEngravingMotion(scene, fail);
    renderers.set(scene, renderer);
    const image = scene.querySelector('.is-active');
    image.decode().then(async () => {
     if (image.classList.contains('is-active')) await renderer.setImage(image, scene.dataset.sceneTopic);
     refreshMotion();
    }).catch(fail);
   } catch { scene.querySelector('canvas')?.remove(); fail(); }
  }
 });
 reduced.addEventListener('change', refreshMotion);
 document.addEventListener('visibilitychange', refreshMotion);
 refreshMotion();
 let sceneRequest = 0;
 async function chooseScene(key) {
  if (!captions[key]) return;
  const request = ++sceneRequest;
  for (const scene of scenes) {
   const next = scene.querySelector(`[data-scene-image="${key}"]`);
   if (!next || scene.dataset.sceneTopic === key) continue;
   try { await next.decode(); } catch { continue; }
   if (request !== sceneRequest) return;
   scene.querySelectorAll('[data-scene-image]').forEach(img => img.classList.toggle('is-active', img === next));
   scene.dataset.sceneTopic = key;
   scene.querySelector('[data-scene-caption]').textContent = captions[key];
   try { await renderers.get(scene)?.setImage(next, key); }
   catch { renderers.get(scene)?.destroy(); renderers.delete(scene); }
   refreshMotion();
  }
 }
 root.querySelectorAll('.pr-topic-row').forEach(row => {
  row.addEventListener('pointerenter', () => { if (matchMedia('(hover:hover)').matches) chooseScene(row.id); });
  row.addEventListener('focus', () => chooseScene(row.id));
 });
 const theme = root.querySelector('[data-report-theme]');
 if (theme) {
  const sync = () => chooseScene(theme.selectedOptions[0]?.dataset.topic);
  theme.addEventListener('change', sync); sync();
 }
 const folio = root.querySelector('.pr-folio-reading');
 let turningPage, turnAnimation;
 const finishTurn = () => {
  turnAnimation?.cancel(); turningPage?.remove(); turningPage=null; turnAnimation=null;
 };
 reduced.addEventListener('change', finishTurn);
 root.addEventListener('pr:focus-changing', event => {
  finishTurn();
  if (!folio || reduced.matches || !event.detail.pointer || document.hidden) return;
  const page = folio.querySelector('.pr-lens');
  turningPage = page.cloneNode(true);
  turningPage.removeAttribute('id');turningPage.removeAttribute('aria-live');
  turningPage.setAttribute('aria-hidden','true');turningPage.inert=true;
  turningPage.classList.add('pr-turning-page');
  turningPage.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
  // The semantic, updated page stays in place; only the old inert leaf turns away.
  turningPage.querySelectorAll('*').forEach(el=>[...el.attributes].filter(a=>a.name.startsWith('data-')).forEach(a=>el.removeAttribute(a.name)));
  folio.append(turningPage);
  turnAnimation=turningPage.animate([
   {transform:'rotateY(0deg)',opacity:1,boxShadow:'-4px 4px 12px #0002'},
   {transform:'rotateY(-48deg)',opacity:1,boxShadow:'-16px 14px 28px #0003',offset:.55},
   {transform:'rotateY(-105deg)',opacity:1,boxShadow:'-8px 6px 16px #0000'}
  ],{duration:750,easing:'cubic-bezier(.25,.46,.45,.94)',fill:'forwards'});
  turnAnimation.onfinish=finishTurn;
 });
 root.dataset.personalMotionReady = 'true';
})();
